'use client'

import {cx} from '@local/utils/cx'
import {useState} from 'react'

interface CounterProps {
	count: number
	className?: string,
	index?: number,
	onChange?: (index: number) => void,
}

export const DotNavigation = ({
	count,
	className,
	onChange,
	index = 0,
}: CounterProps) => {
	const [entries] = useState(new Array(count).fill(null))

	return (
		<div className={cx('flex w-full items-center gap-4', className)}>
			{entries.map((_, i) => (
				<button
					key={i}
					aria-label={`Dot Navigation Item ${i + 1}`}
					className={cx(
						'h-3 w-full bg-black',
						'animation-opacity ease-quart-out duration-300',
						i !== index && 'opacity-50',
					)}
					onClick={() => onChange?.(i)} />
			))}
		</div>
	)
}
